/*
 * @Author: JettyHuang
 * @LastEditors: JettyHuang
 * @Description: 课程信息
 * @Date: 2021-01-06 10:37:49
 * @LastEditTime: 2021-02-04 14:22:06
 * @FilePath: /yft-b2c-web-h5/src/pages/Learn/Course/CourseServ.js
 */
import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 通过产品编号查产品详情
  static getVirProduct(itemCode) {
    return request({
      url: `item/biz/ext/get/code/${itemCode}`,
      host: config.HOST_MALL
    });
  }

  static getBeanNumber() {
    return request({
      url: `bean/personal/beanInfo`,
      host: config.HOST_MALL
    });
  }

  /**
   * 云豆兑换课程资源
   */
  static exchangeCourseByBean(params) {
    return request({
      url: 'bean/item/exchangeBeanLearnResource',
      host: config.HOST_MALL,
      method: 'post_json',
      // ignoreErr: true,
      data: params
    });
  }

  /**
   * 购买课程
   */
  static buyCourse(params, url) {
    return request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data: params
    });
  }

  /**
   * 获取下单可用优惠券
   */
  static getCouponList(data) {
    return request({
      url: `biz/tradecore/trade/query/user-coupon`,
      host: config.HOST_MALL,
      ignoreErr: true,
      method: 'post_json',
      data
    });
  }

  /**
   * 计算价格
   */
  static confirmPrice(data) {
    return request({
      url: `biz/tradecore/trade/confirm`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data
    });
  }

  /**
   * 查询订单提醒
   */
  static getConfirmTip(params) {
    return request({
      url: `basic/reminder/queryReminderForFront`,
      host: config.HOST_MALL,
      method: 'get',
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Learn/component/BuyMadol/BuyModalServ.js